import { registerListResourceWithStore } from '@/services/GenericListResourceService'
import { registerPunchCodesWithStore } from '@/services/PunchCodeService'
import store from '@/store'

registerPunchCodesWithStore(store)

registerListResourceWithStore('entryStates', 'entry/states', store, {
  getters: {
    hasActiveEntryStates: state => state.items.some(item => item.active),
  },
})

export default {
  name: 'punch-settings',
  label: 'Punches',
  link: 'punches',
  path: 'punches',
  props: true,
  icon: 'business-time',
  description: "View and edit your organization's punch settings.",
  redirect: _to => ({
    name: store.getters.hasEntryStateFeature
      ? 'entry-states'
      : 'punch-codes',
  }),
  requirePerm: 'edit_settings',
  require: (state, getters) =>
    getters.hasPunchCodeFeature || getters.hasEntryStateFeature,
  breadcrumbLeaf: true,
}
